var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7844 7.31171C12.7844 7.31171 12.7844 8.94634 14.419 10.581C16.0537 12.2156 17.6883 12.2156 17.6883 12.2156M6.31963 19.9881L9.75234 19.4977C10.2475 19.4269 10.7064 19.1975 11.06 18.8438L19.3229 10.581C20.2257 9.67818 20.2257 8.21449 19.3229 7.31171L17.6883 5.67708C16.7855 4.77431 15.3218 4.77431 14.419 5.67708L6.15616 13.94C5.80248 14.2936 5.57305 14.7525 5.50231 15.2477L5.01193 18.6804C4.90295 19.4432 5.5568 20.097 6.31963 19.9881Z",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.26cbfae3037d9b1f2e8e2f8c9a9f80ca.svg";
export { ForwardRef as ReactComponent };